import {all, call, put, select, takeLatest} from "redux-saga/effects";
import {normalize, schema} from "normalizr";
import {showError} from "utils/sagasErrorHandler";
import {getSiteGroupsRequest} from "services/SiteGroup/api";
import {getSiteGroups, setSiteGroups} from "services/SiteGroup/actions";
import {siteGroupsSelector} from "services/SiteGroup/selectors";

const siteGroupsSchema = new schema.Entity("site_groups", {}, {idAttribute: "code"});
const siteGroupsListSchema = new schema.Array(siteGroupsSchema);

export function* getSiteGroupsWorker() {
    try {
        const {codes} = yield select(siteGroupsSelector);
        if (!codes.length) {
            yield put(setSiteGroups({isLoading: true}));
            const {site_groups} = yield call(getSiteGroupsRequest);
            const {result, entities} = normalize(site_groups, siteGroupsListSchema);
            yield put(setSiteGroups({
                isLoading: false,
                codes: result,
                siteGroups: entities.site_groups
            }));
        }
    } catch (error) {
        yield put(setSiteGroups({isLoading: false}));
        showError(error);
    }
}

export function* getSiteGroupsSagas() {
    yield all([
        yield takeLatest(getSiteGroups, getSiteGroupsWorker)
    ]);
}
